import { render, staticRenderFns } from "./DashboardNavigationMenuComponent.vue?vue&type=template&id=77829a61&scoped=true&"
import script from "./DashboardNavigationMenuComponent.vue?vue&type=script&lang=js&"
export * from "./DashboardNavigationMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNavigationMenuComponent.vue?vue&type=style&index=0&id=77829a61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77829a61",
  null
  
)

export default component.exports